export const config = {
  // backend: 'http://localhost:2052',
  backend: 'https://kouponi.betwidgets.com',
  // backend: 'https://www.betarades.gr:2053',

  corsMessage: {
    el: 'Η υπηρεσία είναι απενεργοποιημένη για τον ιστότοπό σας, παρακαλώ επικοινωνήστε μαζί μας στο support@betwidgets.com',
    en: 'This service is unavailable for your website, please contact us at support@betwidgets.com'
  }
};



// WEBPACK FOOTER //
// ./src/config.js